var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-absolute tw-text-xl tw-left-2 tw-bottom-2"},_vm._l((_vm.users),function(user){return _c('div',{key:user.id,class:user.name === _vm.$auth.user().name ? 'tw-text-green-300' : 'tw-text-yellow-300'},[_vm._v(" "+_vm._s(user.name)+" "),(user.dj)?[_vm._v(" (DJ) ")]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }